module.exports = {
    landingPaperDelay: 4,
    FusionLandingLogo: 'content/skins/fusion/img/FusionLandingLogo.png',
    FusionLandingTitle: 'THE LEADER IN CREDIT UNION LEASING',
    FusionLandingSubTitle: 'LEASING | REMARKETING | FINANCING SOLUTIONS',
    powerBy: {
        header: 'Powered By: ',
        itemList: [
            {
                src: 'content/skins/fusion/img/ManheimLogo.png',
                alt: 'Manheim-Logo',
                href: 'https://www.manheim.com/'
            },
            {
                src: 'content/skins/fusion/img/FusionLogo.png',
                alt: 'Fusion-Logo',
                href: 'https://www.fusionautofinance.com'
            },
            {
                src: 'content/skins/fusion/img/GrooveCarLogo.png',
                alt: 'GrooveCar-Logo',
                href: 'https://www.groovecarinc.com/solutions/groovecar-dealers'
            }
        ]
    },
    introductions: [
        {
            title: 'Exclusive Access',
            description: 'GrooveCar dealers will get exclusive first access to view and purchase off-lease vehicles in the Fusion AutoXchange Private Store.'
        },
        {
            title: 'Extensive Inventory',
            description: 'A large selection of one owner, off-lease cars, trucks, and SUV’s. All condition reports have been completed by professional, independent, third-party inspectors and thoroughly reviewed by the Fusion Auto Finance remarketing team for accuracy. Every vehicle is passed through the NAAA approved AutoGrade algorithm.'
        }
    ],
    registerStep: {
        leftImgSrc: 'content/skins/fusion/img/HappyBunch.png',
        header: 'How to Register for FusionAutoXchange.com:',
        contentSpan: 'Step ',
        steps: [
            {
                description: 'Become a GrooveCar Dealer by Calling\n(631) 454-7500 or Visiting GrooveCarlnc.com',
                href: 'https://www.groovecarinc.com/solutions/groovecar-dealers/'
            },
            {
                description: 'Register with AuctionAccess.com',
                href: 'https://www.auctionaccess.com/'
            },
            {
                description: 'Login to FusionAutoXchange.com to view our inventory!'
            }
        ]
    },
    calvertFamilyOfCompanies: {
        header: 'Calvert Family of Companies',
        itemList: [
            {
                src: 'content/skins/fusion/img/FusionLogo.png',
                alt: 'Fusion-Logo',
                href: 'https://www.fusionautofinance.com'
            },
            {
                src: 'content/skins/fusion/img/GrooveCarLogo.png',
                alt: 'GrooveCar-Logo',
                href: 'https://www.groovecarinc.com/solutions/groovecar-dealers'
            },
            {
                src: 'content/skins/fusion/img/EndTrustLogo.png',
                alt: 'EndTrust-Logo',
                href: 'https://www.endtrust.com/'
            },
            {
                src: 'content/skins/fusion/img/NovakLogo.png',
                alt: 'NovakMotors-Logo',
                href: 'https://www.novakmotors.com/'
            }
        ]
    }
}
